var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircleicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1669 10.3333C18.5474 12.2011 18.2762 14.1428 17.3984 15.8348C16.5206 17.5268 15.0893 18.8667 13.3431 19.6311C11.597 20.3955 9.64154 20.5381 7.80293 20.0353C5.96433 19.5325 4.35368 18.4145 3.23958 16.8678C2.12548 15.3212 1.57529 13.4394 1.68074 11.5361C1.78619 9.63294 2.54092 7.8234 3.81906 6.4093C5.0972 4.9952 6.8215 4.06202 8.7044 3.76537C10.5873 3.46872 12.515 3.82654 14.166 4.77916",
    stroke: "url(#paint0_linear_5682_3970)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.1666L10 13.6666L18.3333 5.33331",
    stroke: "url(#paint1_linear_5682_3970)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5682_3970",
    x1: -7.50926,
    y1: 1.39109,
    x2: 11.105,
    y2: -4.51984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B94FEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5682_3970",
    x1: 1.53481,
    y1: 4.19695,
    x2: 12.9148,
    y2: -0.500862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B94FEB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleicon);
export default __webpack_public_path__ + "static/media/check-circleicon.8e7d7d015a45f4e46b7b306562cf575c.svg";
export { ForwardRef as ReactComponent };